import React from 'react';

import DS_FooterBasicMenuMobile from './mobile';
import DS_FooterBasicMenuDesktop from './desktop';

const DS_FooterBasicMenu = ({ label, items }) => {
  return (
    <>
      <DS_FooterBasicMenuMobile label={label} items={items}></DS_FooterBasicMenuMobile>
      <DS_FooterBasicMenuDesktop label={label} items={items}></DS_FooterBasicMenuDesktop>
    </>
  );
};

export default DS_FooterBasicMenu;
